<template>
  <v-card v-if="visualizza_tabella && modifica_attivo === false">
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"
        >Tabella: {{ tabella_full_sel.titolo }}</v-toolbar-title
      >
      <!-- <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :disabled="admin === false"
            @click="modificaTabella"
            class="mr"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-pencil </v-icon>
          </v-btn>
        </template>
        <span>Modifica tabella</span>
      </v-tooltip> -->
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="goBack" class="mr" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-data-table :headers="tabella_full_sel.colonne" :items="result_query">
    </v-data-table>
  </v-card>
  <v-card v-else>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"
        >{{
          tabella_full_sel.id_query != -1 ? "Modifica" : "Crea"
        }}
        Query</v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="from_esterno === false"
            :disabled="check_save === false"
            @click="salvaTabella"
            class="ml-2"
            v-bind="attrs"
            v-on="on"
            small
            light
          >
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
        </template>
        <span>Salva Tabella</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="from_esterno === false"
            :disabled="check_save === false"
            @click="salvaDictionary"
            class="ml-2"
            v-bind="attrs"
            v-on="on"
            small
            light
          >
            <v-icon color="primary">mdi-download</v-icon>
          </v-btn>
        </template>
        <span>Scarica Fast Reports dictionary</span>
      </v-tooltip>
      <v-btn
        v-if="from_esterno == true"
        :disabled="check_save === false"
        @click="confermaQuery"
        class="ml-2"
        small
        light
        color="success"
      >
        CONFERMA
      </v-btn>
      <v-btn
        class="ml-2"
        small
        :disabled="tabella_full_sel.id_query === -1 && from_esterno == false"
        @click="apriPreview"
        color="success"
      >
        Preview
      </v-btn>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="from_esterno == false"
            @click="goBack"
            class="mr"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="from_esterno == true"
            @click="goBackEsterno"
            class="mr"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-container>
      <v-row
        justify="center"
        align="center"
        class="ma-1"
        v-if="from_esterno === false"
      >
        <v-icon @click="infoValoriDinamici" class="ml-2 mt-2" color="primary"
          >mdi-information</v-icon
        >
        <v-spacer></v-spacer>
        <v-col cols="4">
          <v-text-field
            dense
            hide-details
            outlined
            label="Titolo Tabella"
            v-model="tabella_full_sel.titolo"
          />
        </v-col>
        <v-col cols="4">
          <v-autocomplete
            dense
            hide-details
            outlined
            v-model="tabella_full_sel.modulo"
            :items="moduli_items"
            label="Modulo Tabella"
            placeholder="Seleziona"
            item-text="des"
            item-value="des"
          >
            <!-- <template #label>
              <span class="mr-2">Moduli</span>
              <span @click.stop style="min-width: 500px; pointer-events: all">
                <Modules
                  v-on:dialogModules="getTabelleModuli"
                  tipo="MODULI_TABELLE_STATISTICHE"
                  nome="Modulo"
                  setaction="settabella"
                  getaction="gettabella"
                  controller="Global"
                  :controllaCodice="true"
                  :filter="'validita = 1'"
                  :all_label="['Modulo']"
                  :dati="[{ des: '' }]"
                />
              </span>
            </template> -->
          </v-autocomplete>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="center" align="center" v-if="from_esterno === false">
        <v-col cols="10">
          <v-textarea
            rows="2"
            outlined
            label="Descrizione query"
            v-model="tabella_full_sel.query[0].descrizione"
            @change="logChange"
          />
        </v-col>
      </v-row>
      <QueryEditor
        @analyze="checkAnalyze"
        v-model="tabella_query_editor_sel"
        :template="template"
      />
      <v-row align="center" justify="center">
        <v-col>
          <v-expansion-panels :key="key_pam_col">
            <!-- Tab Prarametri -->

            <v-expansion-panel>
              <v-expansion-panel-header>Parametri</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :headers="headers_parametri"
                  :items="tabella_query_editor_sel.parametri"
                >
                  <template v-slot:[`item.value`]="{ item }">
                    <v-text-field
                      v-model="item.value"
                      required
                      label="Inserisci un valore"
                    />
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Tabella Creazione Colonne -->
            <v-expansion-panel>
              <v-expansion-panel-header>Serie</v-expansion-panel-header>
              <v-expansion-panel-content
                v-if="tabella_query_editor_sel.colonne"
              >
                <v-data-table
                  v-if="tabella_query_editor_sel.colonne.length != 1"
                  :headers="headers"
                  :items="tabella_query_editor_sel.colonne"
                >
                  <template v-slot:item="{ item }">
                    <tr
                      class="record_tabella"
                      :data-deleted="item.error == 1 ? true : false"
                    >
                      <td>
                        <v-text-field
                          label="Testo Colonna"
                          v-model="item.text"
                        />
                      </td>
                      <td>
                        <v-text-field
                          label="Valore Colonna"
                          v-model="item.value"
                        />
                      </td>
                      <td style="text-align: left">
                        <v-select
                          style="display: inline-block; max-width: 200px"
                          :items="tipologiaAlign"
                          item-text="des"
                          item-value="value"
                          label="Seleziona"
                          v-model="item.align"
                        ></v-select>
                      </td>
                      <td style="text-align: left">
                        <v-checkbox v-model="item.sortable" />
                      </td>
                      <!-- <td style="text-align: left">
                        <v-checkbox v-model="item.visible" />
                      </td> -->
                      <td style="text-align: left">
                        <v-btn @click="apriDialofFormato(item)" small>
                          <v-icon color="indigo">mdi-palette</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-data-table
                  v-else
                  :headers="headers_with_ass"
                  :items="tabella_query_editor_sel.colonne"
                >
                  <template v-slot:item="{ item }">
                    <tr
                      class="record_tabella"
                      :data-deleted="item.error == 1 ? true : false"
                    >
                      <td>
                        <v-text-field
                          label="Testo Colonna"
                          v-model="item.text"
                        />
                      </td>
                      <td>
                        <v-text-field
                          label="Valore Colonna"
                          v-model="item.value"
                        />
                      </td>
                      <td style="text-align: left">
                        <v-select
                          style="display: inline-block; max-width: 200px"
                          :items="tipologiaAlign"
                          item-text="des"
                          item-value="value"
                          label="Seleziona"
                          v-model="item.align"
                        ></v-select>
                      </td>
                      <td style="text-align: left">
                        <v-checkbox v-model="item.sortable" />
                      </td>
                      <!-- <td style="text-align: left">
                        <v-checkbox v-model="item.visible" />
                      </td> -->
                      <td style="text-align: left">
                        <v-btn @click="apriDialofFormato(item)" small>
                          <v-icon color="indigo">mdi-palette</v-icon>
                        </v-btn>
                      </td>
                      <td style="text-align: left">
                        <v-btn
                          :disabled="tabella_full_sel.id_query == -1"
                          @click="apriDialogAssociazioneQuery(item)"
                          small
                        >
                          <v-icon color="indigo">mdi-database-plus</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- NOMI TABELLE -->
            <v-expansion-panel>
              <v-expansion-panel-header>Tabelle</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-data-table
                  :headers="headers_nome_tabelle"
                  :items="tabella_query_editor_sel.tabelle"
                >
                  <template v-slot:[`item.value`]="{ item }">
                    <v-text-field
                      v-model="item.value"
                      required
                      label="Inserisci un valore"
                    />
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- <v-row align="center" justify="center">
        <v-col cols="10">
          <v-textarea
            :disabled="tabella_sel.id_query == -1"
            outlined
            rows="3"
            label="Query Tabella"
            v-model="query_sel.query"
          />
        </v-col>
        <v-col>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="tabella_sel.id_query == -1"
                @click="salvaQuery"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva Query</span>
          </v-tooltip>
        </v-col>
      </v-row> -->
    </v-container>

    <!-- Dialog Preview Colonne  -->
    <v-dialog v-model="visualizza_preview" width="unset" persistent>
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Preview Tabella
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  visualizza_preview = false;
                  clearVisualizza();
                "
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                small
                light
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-container>
          <v-container class="pa-2" v-if="array_tabelle_preview.length">
            <v-row v-for="(table, i) in array_tabelle_preview" :key="i">
              <v-toolbar color="indigo" dense>
                <v-toolbar-title class="white--text">
                  {{ table.name }}
                </v-toolbar-title>
              </v-toolbar>
              <v-data-table :headers="table.colonne" :items="table.result">
                <!-- <template v-slot:item="{ item }">
            <tr>
              <td
                v-for="(colonna, index) in result_query.colonne"
                :style="calcoloFormato(item, colonna)"
                :key="index"
              >
                {{ item[colonna.value] }}
              </td>
            </tr>
          </template> -->
              </v-data-table>
            </v-row>
          </v-container>
          <v-container v-else>
            <v-data-table
              v-if="result_query.colonne"
              :headers="result_query.colonne"
              :items="result_query"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td
                    v-for="(colonna, index) in result_query.colonne"
                    :style="calcoloFormato(item, colonna)"
                    :key="index"
                  >
                    {{ item[colonna.value] }}
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-card-text v-else class="mt-4">
              {{ result_query }}
            </v-card-text>
          </v-container>

          <v-overlay :value="overlay3">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-container>
        <!-- ORI -->
        <!-- <v-data-table
        :headers="tabella_query_editor_sel.colonne"
        :items="result_query"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td
              v-for="(colonna, index) in tabella_query_editor_sel.colonne"
              :style="calcoloFormato(item, colonna)"
              :key="index"
            >
              {{ item[colonna.value] }}
            </td>
          </tr>
        </template>
      </v-data-table> -->
        <!-- <v-data-table
          v-if="result_query.colonne"
          :headers="result_query.colonne"
          :items="result_query"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td
                v-for="(colonna, index) in result_query.colonne"
                :style="calcoloFormato(item, colonna)"
                :key="index"
              >
                {{ item[colonna.value] }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-card-text v-else class="mt-4">
          {{ result_query }}
        </v-card-text> -->
        <!-- <v-toolbar v-if="result_query_associated.length > 0" color="indigo" dense>
        <v-toolbar-title class="white--text"> Preview Query Associata</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar> -->
        <!-- <v-data-table
       v-if="result_query_associated.length > 0"
        :headers="header_query_associated"
        :items="result_query_associated"
      >
       <template v-slot:item="{ item }">
          <tr>
            <td
              v-for="(colonna, index) in result_query_associated."
              :style="calcoloFormato(item, colonna)"
              :key="index"
            >
              {{ item[colonna.value] }}
            </td>
          </tr>
        </template>
      </v-data-table> -->
        <v-overlay :value="overlay3">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>

    <!-- Dialog Info Valori  -->
    <v-dialog v-model="visualizza_info_valori" width="unset">
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text"> Info </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="visualizza_info_valori = false"
              class="ml-2"
              v-bind="attrs"
              v-on="on"
              small
              light
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-data-table :headers="headers_info" :items="items_info">
        <template v-slot:item="{ item, index }">
          <tr>
            <td>
              <v-text-field :id="'id' + index" readonly v-model="item.label" />
            </td>
            <td>
              <v-text-field readonly v-model="item.value" />
            </td>
            <td style="text-align: left">
              <v-btn small @click="copyValue(index)">
                <v-icon color="primary">mdi-content-copy</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-dialog>

    <!-- Dialog Associazione Query  -->
    <v-dialog v-model="dialog_associa_query" width="unset" persistent>
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Associa Query </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="aggAssociazione"
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                small
                light
              >
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Agg. Associazione</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="clickSalvaAssocQuery"
                v-bind="attrs"
                v-on="on"
                small
                light
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva Associazione</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="chiudiDialogAss"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
                small
                light
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-container>
          <v-row
            v-for="(elem, i) in associazioni_query.filter(
              (e) => e.validita == 1
            )"
            :key="i"
            align="center"
            justify="center"
          >
            <v-col>
              <v-select
                style="display: inline-block; width: 140px"
                :items="array_condition"
                item-text="text"
                item-value="value"
                label="Condizione"
                v-model="elem.condizione"
              ></v-select>
            </v-col>
            <v-col>
              <v-text-field
                style="display: inline-block; width: 90px"
                v-model="elem.valore_condizionale"
                label="Valore"
              />
            </v-col>
            <v-col v-show="elem.condizione == '><'">
              <v-text-field
                style="display: inline-block; width: 90px"
                v-model="elem.valore_condizionale2"
                label="Valore 2"
              />
            </v-col>
            <v-col>
              <v-select
                style="display: inline-block; width: 180px"
                :items="array_tabelle"
                item-text="titolo"
                item-value="id_query"
                label="Seleziona query positiva"
                v-model="elem.id_positive_query"
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                style="display: inline-block; width: 180px"
                :items="array_tabelle"
                item-text="titolo"
                item-value="id_query"
                label="Seleziona query negativa"
                v-model="elem.id_negative_query"
              ></v-select>
            </v-col>

            <v-col>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="eliminaAssociazione(elem)"
                    v-bind="attrs"
                    v-on="on"
                    small
                    light
                  >
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Elimina</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-container>
        <!-- Overlay -->
        <v-overlay :value="overlay2">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-dialog>
    <FormatoQTT
      v-model="formato"
      :show="show_formato"
      :item="item_formato"
      @chiudi_dialg_formato="show_formato = false"
    />

    <SnackbarQV ref="SnackbarQV" />
    <!-- Overlay -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import TabellaCustomClass from "@/classes/TabellaCustomClass.js";
import QueryEditor from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";
import FormatoQTT from "@/components/TABELLA_CUSTOM/FormatoQTT.vue";
// import Modules from "@/components/TOOLS/Modules";

class Colonna {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "id_query_serie", default_val: -1 },
      { nome: "id_query", default_val: -1 },
      { nome: "text", default_val: "" },
      { nome: "value", default_val: "" },
      { nome: "formato", default_val: "" },
      { nome: "align", default_val: "" },
      { nome: "ordine", default_val: 0 },
      { nome: "sortable", default_val: 0 },
      // { nome: "visible", default_val: 0 },
      { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

class Query {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "id_query_dettaglio ", default_val: -1 },
      { nome: "id_query", default_val: -1 },
      { nome: "query", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

class AssociazioneQuery {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "id_query_associate", default_val: -1 },
      { nome: "id_query_serie", default_val: -1 },
      { nome: "id_query", default_val: -1 },
      { nome: "id_positive_query", default_val: -1 },
      { nome: "id_negative_query", default_val: -1 },
      { nome: "query_comparison_field", default_val: "" },
      { nome: "valore_condizionale", default_val: "" },
      { nome: "valore_condizionale2", default_val: "" },
      { nome: "condizione", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

export default {
  name: "TabellaCustom",
  components: {
    SnackbarQV,
    QueryEditor,
    FormatoQTT,
    // Modules,
  },
  props: {
    from_adapter: {
      type: Boolean,
      default: false,
    },
    from_esterno: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
    visualizza_dialog_tabella_custom: {
      type: Boolean,
      default: false,
    },
    // tabella: {
    //   type: Object,
    //   default: null,
    // },
    tabella_full: {
      type: Object,
      default: null,
    },
    save_table_snack: {
      type: Boolean,
      default: false,
    },
    query: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      colonna_sel: new Colonna(),
      query_sel: new Query(),
      tabella_query_editor_sel: {},
      tabella_full_sel: new TabellaCustomClass(),
      formato: "",
      item_formato: {},
      original_query: "",
      check_save: false,
      overlay: false,
      overlay2: false,
      overlay3: false,
      serie_sel: null,
      key_pam_col: 0,

      // Modal
      admin: false,
      dialog_associa_query: false,
      modifica_attivo: false,
      visualizza_tabella: false,
      visualizza_preview: false,
      visualizza_result_query: false,
      visualizza_info_valori: false,
      show_formato: false,

      // Array
      associazioni_query: [],
      array_condition: [
        { text: "Uguale a", value: "=" },
        { text: "Maggiore di", value: ">" },
        { text: "Maggiore o uguale a", value: ">=" },
        { text: "Minore di", value: "<" },
        { text: "Minore o uguale ", value: "<=" },
        { text: "Compreso tra", value: "><" },
      ],
      array_tabelle: [],
      items_info: new Array(),

      headers: [
        { text: "Text", value: "text" },
        { text: "Value", value: "value" },
        // { text: "Ordine", value: "ordine" },
        { text: "Align", value: "align" },
        { text: "Sortable", value: "sortable" },
        // { text: "Visible", value: "visible" },
        { text: "Formato", value: "formato" },
      ],
      headers_with_ass: [
        { text: "Text", value: "text" },
        { text: "Value", value: "value" },
        // { text: "Ordine", value: "ordine" },
        { text: "Align", value: "align" },
        { text: "Sortable", value: "sortable" },
        // { text: "Visible", value: "visible" },
        { text: "Formato", value: "formato" },
        { text: "Ass. Query", value: "ass_query" },
      ],
      headers_info: [
        { text: "Descrizione", value: "label" },
        { text: "Valore", value: "value" },
        { text: "Copia", value: "copia" },
      ],
      headers_parametri: [
        { text: "Label", value: "label" },
        { text: "Valore", value: "value" },
      ],
      headers_nome_tabelle: [
        { text: "Valore Originale", value: "label" },
        { text: "Numero Riga", value: "riga" },
        { text: "Valore Nuovo", value: "value" },
      ],
      moduli_items: [],
      tipologiaAlign: [
        { des: "Left", value: "left" },
        { des: "Center", value: "center" },
        { des: "Right", value: "right" },
      ],

      result_query: [],
      result_query_associated: [],
      header_query_associated: [],
      template: [],
      array_tabelle_preview: [],
    };
  },
  computed: {},
  watch: {
    visualizza_dialog_tabella_custom: {
      immediate: true,
      handler() {
        if (this.visualizza_dialog_tabella_custom === true) {
          this.getTabelle();
        }
      },
    },
    save_table_snack: {
      immediate: true,
      handler() {
        if (this.save_table_snack === true) {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "success",
            "Tabella salvata correttamente."
          );

          this.save_table_snack = false;
        }
      },
    },
    // query: {
    //   immediate: true,
    //   handler() {
    //     console.log("watch query", this.from_esterno, this.query);
    //     if (this.tabella_full == null) {
    //         this.tabella_full = new TabellaCustomClass();
    //         this.tabella_full.query1 = [{query: ""}];
    //       this.tabella_full.query1[0].query = this.query;
    //     }

    // },
    // },
    tabella_query_editor_sel: {
      immediate: true,
      handler() {
        console.log("entra 1");
        this.template = [
          {
            targetProperty: "cod",
            color: "red",
            keyword: "@",
            targetField: "parametri",
            getTemplate(detail, code) {
              window.x = detail;
              return {
                id_query_preview: -1,
                id_query: -1,
                label: code,
                value: "",
                validita: 1,
              };
            },
          },
          {
            targetProperty: "cod",
            color: "blue",
            keyword: "#",
            targetField: "colonne",
            getTemplate(detail, code) {
              window.x = detail;
              return {
                align: "",
                formato: "",
                id_query: -1,
                id_query_serie: -1,
                ordine: null,
                sortable: null,
                text: code.includes("#N_")
                  ? code.split("#N_")[1].replaceAll("_", " ")
                  : code.includes("#S_")
                  ? code.split("#S_")[1].replaceAll("_", " ")
                  : code.includes("#D_")
                  ? code.split("#D_")[1].replaceAll("_", " ")
                  : code.split("#")[1].replaceAll("_", " "),
                validita: 1,
                value: code.split("#")[1],
                // visible: true,
              };
            },
          },
        ];
      },
    },
    tabella_full: {
      immediate: true,
      handler() {
        if (this.tabella_full == null) {
          console.log("entra 2");
          console.log("query from prop", this.query);
          this.tabella_full_sel = new TabellaCustomClass();
          if (this.query != "") {
            this.tabella_query_editor_sel.tabelle = [];
            this.tabella_query_editor_sel.query = this.query;
            this.original_query = this.query;
            if (this.tabella_query_editor_sel.query != "") {
              console.log("Entra in tabella full watch if");
              let arr_queries = this.tabella_query_editor_sel.query.split(";");
              let count = 0;
              arr_queries.forEach((e) => {
                if (e != "") {
                  let obj_tmp = {
                    label: "Table" + count,
                    value: "",
                    riga: count,
                  };
                  this.tabella_query_editor_sel.tabelle.push(obj_tmp);
                  count++;
                }
              });
            }
          }

          console.log(
            " this.tabella_query_editor_sel.query",
            this.tabella_query_editor_sel
          );

          const that = this;

          this.template = [
            {
              targetProperty: "cod",
              color: "red",
              keyword: "@",
              targetField: "parametri",
              getTemplate(detail, code) {
                window.x = detail;

                let value_param = null;
                let id_param = null;

                console.log("detail:", detail);
                console.log("code", code);

                console.log("that.tabella_full_sel", that.tabella_full_sel);

                that.tabella_full_sel.params.forEach((param) => {
                  if (param.label == code) {
                    value_param = param.value;
                    id_param = param.id_query_preview;
                  }
                });
                return {
                  id_query_preview: id_param,
                  id_query: that.tabella_full_sel.id_query,
                  label: code,
                  value: value_param,
                  validita: 1,
                };
              },
            },
            {
              targetProperty: "cod",
              color: "blue",
              keyword: "#",
              targetField: "colonne",
              getTemplate(detail, code) {
                window.x = detail;
                let align_col = null;
                let formato_col = null;
                let id_col = null;
                let ordine_col = null;
                let sort_col = null;
                let text_col = null;
                // let visible_col = null;

                that.tabella_full_sel.colonne.forEach((col) => {
                  if (col.value == code.split("#")[1]) {
                    align_col = col.align;
                    formato_col = col.formato;
                    id_col = col.id_query_serie;
                    ordine_col = col.ordine;
                    sort_col = col.sortable;
                    text_col = col.text;
                    // visible_col = col.visible;
                  } else {
                    text_col = code.includes("#N_")
                      ? code.split("#N_")[1].replaceAll("_", " ")
                      : code.includes("#S_")
                      ? code.split("#S_")[1].replaceAll("_", " ")
                      : code.includes("#D_")
                      ? code.split("#D_")[1].replaceAll("_", " ")
                      : code.split("#")[1].replaceAll("_", " ");

                    console.log("text_col", text_col);
                  }
                });
                return {
                  align: align_col,
                  formato: formato_col,
                  id_query: that.tabella_full_sel.id_query,
                  id_query_serie: id_col,
                  ordine: ordine_col,
                  sortable: sort_col,
                  text: text_col,
                  validita: 1,
                  value: code.split("#")[1],
                  // visible: visible_col,
                };
              },
            },
          ];
        } else if (this.tabella_full.id_query != -1) {
          console.log("entra 3");
          console.log("entra if id_query");
          this.tabella_full_sel = this.tabella_full;
          this.tabella_query_editor_sel.colonne = this.tabella_full.colonne;
          this.tabella_query_editor_sel.tabelle = [];

          if (this.tabella_full.query1.length != 0) {
            console.log("entra query1.length");
            this.tabella_query_editor_sel.query = this.tabella_full.query1[0].query;
            this.original_query = this.tabella_full.query1[0].query;
            if (this.tabella_query_editor_sel.query != "") {
              console.log("Entra in tabella full watch else");
              let arr_queries = this.tabella_query_editor_sel.query.split(";");
              console.log("arr_queries", arr_queries);
              let count = 0;
              arr_queries.forEach((e) => {
                if (e != "") {
                  let obj_tmp = {
                    label: "Table" + count,
                    value: "",
                  };
                  this.tabella_query_editor_sel.tabelle.push(obj_tmp);
                  count++;
                }
              });
            }
          }

          console.log(
            " this.tabella_query_editor_sel.query",
            this.tabella_query_editor_sel
          );

          const that = this;

          this.template = [
            {
              targetProperty: "cod",
              color: "red",
              keyword: "@",
              targetField: "parametri",
              getTemplate(detail, code) {
                window.x = detail;

                let value_param = null;
                let id_param = null;

                console.log("detail:", detail);
                console.log("code", code);

                console.log("that.tabella_full_sel", that.tabella_full_sel);

                that.tabella_full_sel.params.forEach((param) => {
                  if (param.label == code) {
                    value_param = param.value;
                    id_param = param.id_query_preview;
                  }
                });
                return {
                  id_query_preview: id_param,
                  id_query: that.tabella_full_sel.id_query,
                  label: code,
                  value: value_param,
                  validita: 1,
                };
              },
            },
            {
              targetProperty: "cod",
              color: "blue",
              keyword: "#",
              targetField: "colonne",
              getTemplate(detail, code) {
                window.x = detail;
                let align_col = null;
                let formato_col = null;
                let id_col = null;
                let ordine_col = null;
                let sort_col = null;
                let text_col = null;
                // let visible_col = null;

                that.tabella_full_sel.colonne.forEach((col) => {
                  if (col.value == code.split("#")[1]) {
                    align_col = col.align;
                    formato_col = col.formato;
                    id_col = col.id_query_serie;
                    ordine_col = col.ordine;
                    sort_col = col.sortable;
                    text_col = col.text;
                    // visible_col = col.visible;
                  } else {
                    text_col = code.includes("#N_")
                      ? code.split("#N_")[1].replaceAll("_", " ")
                      : code.includes("#S_")
                      ? code.split("#S_")[1].replaceAll("_", " ")
                      : code.includes("#D_")
                      ? code.split("#D_")[1].replaceAll("_", " ")
                      : code.split("#")[1].replaceAll("_", " ");

                    console.log("text_col", text_col);
                  }
                });
                return {
                  align: align_col,
                  formato: formato_col,
                  id_query: that.tabella_full_sel.id_query,
                  id_query_serie: id_col,
                  ordine: ordine_col,
                  sortable: sort_col,
                  text: text_col,
                  validita: 1,
                  value: code.split("#")[1],
                  // visible: visible_col,
                };
              },
            },
          ];
        } else {
          console.log("entra 4");
          const query = new Query();
          this.tabella_full_sel.query.push(query);
          this.tabella_query_editor_sel.query = "";
        }
      },
    },
  },
  methods: {
    logChange() {
      console.log("change des", this.tabella_full_sel);
    },
    clearVisualizza() {
      this.result_query = [];
      this.result_query_associated = [];
      this.header_query_associated = [];
    },
    apriDialofFormato(item) {
      console.log("item", item);
      this.item_formato = item;
      console.log(this.item_formato);
      this.formato = item.formato;
      this.show_formato = true;
    },
    apriDialogAssociazioneQuery(item) {
      console.log("btn ass:", item);
      this.serie_sel = item;
      this.getTabella();
      this.getAssociazioniQuery();

      this.dialog_associa_query = true;
    },
    aggAssociazione() {
      let obj_ass = new AssociazioneQuery();
      console.log("this.serie_sel", this.serie_sel);
      obj_ass.query_comparison_field = this.serie_sel.value;
      obj_ass.id_query_serie = this.serie_sel.id_query_serie;
      this.associazioni_query.push(obj_ass);
    },
    aggiungiColonna() {
      this.tabella_sel.colonne.unshift(new Colonna());
    },
    async salvaDictionary() {
      this.overlay = true;
      if (this.tabella_query_editor_sel.parametri.length != 0) {
        let showSnack = false;
        this.tabella_query_editor_sel.parametri.forEach((par) => {
          if (
            par.value === undefined ||
            par.value === null ||
            par.value === ""
          ) {
            showSnack = true;
          }
        });
        if (showSnack === false) {
          await this.playQuery();
          this.getAssociazioniQuery();
        } else {
          this.$refs.SnackbarQV.print("orange", "Parametri mancanti.");
        }
      } else if (this.tabella_query_editor_sel.parametri.length == 0) {
        await this.playQuery();
        this.getAssociazioniQuery();
      }
      console.log(this.result_query[0]);
      var frd =
        '<?xml version="1.0" encoding="utf-8"?>\n' +
        "<Dictionary>\n" +
        '<TableDataSource Name="TABELLA" ReferenceName="DataSet.TABELLA"' +
        ' DataType="System.Int32" Enabled="true">\n';
      Object.keys(this.result_query[0]).forEach((e) => {
        frd += '<Column Name="' + e + '" DataType=';
        if (/^\d+$/.test(this.result_query[0][e])) frd += '"System.Int32"/>\n';
        else frd += '"System.String"/>\n';
      });
      frd += "</TableDataSource>\n</Dictionary>";

      const temp = document.createElement("a");
      const file = new Blob([frd], { type: "text/plain" });
      temp.href = URL.createObjectURL(file);
      temp.setAttribute("download", "dictionary.frd");
      document.body.appendChild(temp);
      temp.click();
      document.body.removeChild(temp);

      console.log(frd);
      this.overlay = false;
    },
    apriPreview() {
      if (this.tabella_query_editor_sel.parametri.length != 0) {
        let showSnack = false;
        let showSnackTab = false;
        this.tabella_query_editor_sel.tabelle.forEach((e) => {
          if (e.value == "") {
            this.$refs.SnackbarQV.print("orange", "Inserire un nome tabella.");
            showSnackTab = true;
          }
        });

        this.tabella_query_editor_sel.parametri.forEach((par) => {
          if (
            par.value === undefined ||
            par.value === null ||
            par.value === ""
          ) {
            showSnack = true;
            this.$refs.SnackbarQV.print("orange", "Parametri mancanti.");
          }
        });
        if (showSnack === false && showSnackTab === false) {
          let query_str = "";
          this.tabella_query_editor_sel.parametri.forEach((p) => {
            console.log("parametro", p);
            if (this.tabella_query_editor_sel.query.includes(p.cod)) {
              console.log("match parametro in query");
              query_str =
                query_str != ""
                  ? query_str.replaceAll(p.cod, p.value)
                  : this.tabella_query_editor_sel.query.replaceAll(
                      p.cod,
                      p.value
                    );
              console.log(
                "query con params:",
                this.tabella_query_editor_sel.query
              );
            }
          });

          console.log("query con value ", query_str);

          let request = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
              action: "performquery",
              token: localStorage.user_token,
              query_string: query_str,
              tabelle: this.tabella_query_editor_sel.tabelle,
            },
          };

          this.$store
            .dispatch("api", request)
            .then((res) => {
              if (res.status === 200) {
                this.visualizza_preview = true;
                this.array_tabelle_preview = [];
                for (const [e, value] of Object.entries(res.data.result)) {
                  let obj_tmp = {
                    colonne: [],
                    name: e,
                    result: value,
                  };

                  let headers = [];
                  for (let field in value[0]) {
                    headers.push({
                      text: field.includes("#")
                        ? field.split("#")[1].replaceAll("_", " ")
                        : field.replaceAll("_", " "),
                      value: field,
                      sortable: false,
                    });
                  }

                  obj_tmp.colonne = headers;
                  this.array_tabelle_preview.push(obj_tmp);
                }
                console.log(
                  "this.array_tabelle_preview",
                  this.array_tabelle_preview
                );
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  "Nessun risultato trovato."
                );
              }
              this.overlay3 = false;
            })
            .catch((err) => {
              this.overlay3 = false;

              /* Se c'è un messaggio di errore (SQL) lo stampo, 
               * altrimenti stampo una snackbar di errore generica. */
              if (
                err.response &&
                err.response.data &&
                err.response.data.message &&
                JSON.parse(err.response.data.message).errorMessage
              ) {
                this.$refs.SnackbarQV.print(
                  "error",
                  `${JSON.parse(err.response.data.message).errorMessage}.`
                );
              } else {
                console.error(err);
                this.$refs.SnackbarQV.print(
                  "error",
                  "Errore di comunicazione col server, impossibile recuperare i dati."
                );
              }
            });
        }
      } else if (this.tabella_query_editor_sel.parametri.length == 0) {
        this.visualizza_preview = true;
        this.playQuery();
        this.getAssociazioniQuery();
      }
    },
    calcoloFormato(valore_cella, colonna) {
      console.log("valore cella", valore_cella);
      console.log("colonna in calcolo formato", colonna);

      valore_cella = valore_cella[colonna.value];
      console.log(valore_cella);

      let formato = null;

      try {
        // il campo EXTRA è un json codificato in base64 (con supporto per UTF-8)
        formato = JSON.parse(decodeURIComponent(escape(atob(colonna.formato))));

        console.log(formato);
      } catch (error) {
        return undefined;
      }

      let style = null;
      let valore_cella_cast;
      let tipo_dato;

      if (isFinite(Number(valore_cella)) && valore_cella != null) {
        valore_cella_cast = Number(valore_cella);
        tipo_dato = "numero";
      } else if (isFinite(Date.parse(valore_cella)) && valore_cella != null) {
        valore_cella_cast = Date.parse(valore_cella);
        tipo_dato = "data";
      } else {
        if (valore_cella == null) {
          valore_cella_cast = "";
        } else {
          valore_cella_cast = valore_cella.toString();
        }
        tipo_dato = "stringa";
      }

      const operazioni_numeriche = [
        function (item, test) {
          return item < test;
        },
        function (item, test) {
          return item <= test;
        },
        function (item, test) {
          return item == test;
        },
        function (item, test) {
          return item >= test;
        },
        function (item, test) {
          return item > test;
        },
        function (item, test) {
          return item != test;
        },
      ];

      const operazioni_stringa = [
        function () {
          return false;
        },
        function () {
          return false;
        },
        function (item, test, case_sensitive) {
          if (case_sensitive == true) {
            return item == test;
          } else {
            return item.toLowerCase() == test.toLowerCase();
          }
        },
        function () {
          return false;
        },
        function () {
          return false;
        },
        function (item, test, case_sensitive) {
          if (case_sensitive == true) {
            return item != test;
          } else {
            return item.toLowerCase() != test.toLowerCase();
          }
        },
      ];

      formato.forEach((regola) => {
        if (regola.static === true) {
          style = regola.compiled_style;
          return;
        }

        if (regola.range === true) {
          switch (tipo_dato) {
            case "numero":
              if (
                valore_cella_cast >= Number(regola.start_ref) &&
                valore_cella_cast <= Number(regola.end_ref)
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
            case "data":
              if (
                valore_cella_cast >= Date.parse(regola.start_ref) &&
                valore_cella_cast <= Date.parse(regola.end_ref)
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
          }
        } else {
          switch (tipo_dato) {
            case "stringa":
              if (
                operazioni_stringa[Number(regola.operation)](
                  valore_cella_cast,
                  regola.start_ref
                )
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
            case "numero":
              if (
                operazioni_numeriche[Number(regola.operation)](
                  valore_cella_cast,
                  Number(regola.start_ref)
                )
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
            case "data":
              if (
                operazioni_numeriche[Number(regola.operation)](
                  valore_cella_cast,
                  Date.parse(regola.start_ref)
                )
              ) {
                style = regola.compiled_style;
                return;
              }
              break;
          }
        }
      });

      return style;
    },
    clickSalvaAssocQuery() {
      this.associazioni_query.forEach((e) => {
        e.id_query = this.tabella_full.id_query;
      });
      console.log("query associate: ", this.associazioni_query);

      this.overlay2 = true;
      let request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setqueryassociate",
          token: localStorage.user_token,
          queryassociate: this.associazioni_query,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status == 200) {
          this.dialog_associa_query = false;
          this.associazioni_query = [];
          this.serie_sel = null;
          this.$refs.SnackbarQV.print("success", "Dati salvati con successo.");
        } else {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
        }
        this.overlay2 = false;
      });
    },
    confermaQuery() {
      console.log(
        "click conferma fai un emit",
        this.tabella_query_editor_sel.query
      );
      this.$emit("conferma_query", this.tabella_query_editor_sel.query);
      this.$emit("chiudi_dialog");
    },
    copyValue(index) {
      var copyText = document.querySelector("#id" + index);
      copyText.select();

      document.execCommand("copy");
    },
    checkAnalyze(status) {
      this.tabella_query_editor_sel.tabelle = [];
      let arr_queries = this.tabella_query_editor_sel.query.split(";");
      let count = 0;
      arr_queries.forEach((e) => {
        if (e != "") {
          let obj_tmp = {
            label: "Table" + count,
            value: "Table" + count,
            riga: count,
          };
          this.tabella_query_editor_sel.tabelle.push(obj_tmp);
          count++;
        }
      });
      this.key_pam_col = this.key_pam_col == 0 ? 1 : 0;
      this.check_save = !status;
    },
    chiudiDialogAss() {
      this.dialog_associa_query = false;
      this.serie_sel = null;
      this.associazioni_query = [];
    },
    eliminaColonna(item) {
      item.validita = 0;
    },
    eliminaAssociazione(elem) {
      elem.validita = 0;
      if (elem.id_query_associate != -1) {
        this.clickSalvaAssocQuery();
      }
    },
    getAssociazioniQuery() {
      this.overlay2 = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getqueryassociate",
          token: localStorage.user_token,
          id_query: this.tabella_full.id_query,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        console.log("res getassquery", res);
        if (res.data.asqueries.associativequeries.length > 0) {
          console.log("entra res.data.asqueries.associativequeries.length");
          this.associazioni_query = res.data.asqueries.associativequeries;
          // res.data.asqueries.associativequeries.forEach(e => {
          //   // da sostituire con l id_query_serie
          //   if (e.query_comparison_field === this.serie_sel.value) {
          //     console.log("e.query_comparison_field === this.serie_sel.value", e.query_comparison_field, this.serie_sel.value);
          //     this.associazioni_query.push(e);
          //   }
          // })
        }

        if (this.associazioni_query.length == 0 && this.serie_sel != null) {
          console.log("entra this.associazioni_query.length", this.serie_sel);
          let obj_ass = new AssociazioneQuery();
          obj_ass.query_comparison_field = this.serie_sel.value;
          this.associazioni_query.push(obj_ass);
        }

        this.overlay3 = false;
        this.overlay2 = false;
      });
    },
    getTabella() {
      this.overlay2 = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getquerydettaglio",
          token: localStorage.user_token,
          // tipologia: this.tabella_sel.modulo,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.data.result.query.length != 0) {
          this.array_tabelle = res.data.result.query.filter(
            (e) =>
              e.modulo == this.tabella_full_sel.modulo &&
              e.id_query != this.tabella_full_sel.id_query
          );
          this.overlay2 = false;
          // this.tabella_sel = res.data.result.tabelle_statistiche[0];

          // if (res.data.result.tabelle_statistiche[0].query) {
          //   if (res.data.result.tabelle_statistiche[0].query.length != 0) {
          //     this.query_sel = res.data.result.tabelle_statistiche[0].query[0];
          //     this.playQuery();
          //   }
          // }

          // this.visualizza_tabella = true;
        }
      });
    },

    getTabelle() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "PARAMETRI_QUERY",
          filter: "validita = 1",
        },
      };
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_info = new Array();
            res.data.forEach((p) => {
              const obj_tmp = {};
              obj_tmp.label = p.cod;
              obj_tmp.value = p.des;
              this.items_info.push(Object.assign({}, obj_tmp));
            });

            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch(() => {
          // this.$refs.SnackbarQV.print(
          //   "error",
          //   "Errore di comunicazione col server, non è stato possibile caricare i dati."
          // );
          // return false;
        });
    },
    getTabelleModuli() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: "MODULI_TABELLE_STATISTICHE",
          filter: "validita = 1",
        },
      };
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.moduli_items = res.data;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    goBack() {
      this.modifica_attivo = false;
      this.$emit("click_indietro");
      this.$emit("save_table");
      this.result_query = [];
      this.result_query_associated = [];
      this.header_query_associated = [];
    },
    goBackEsterno() {
      this.$emit("click_indietro");
      this.$emit("chiudi_dialog");
    },
    infoValoriDinamici() {
      this.visualizza_info_valori = true;
    },
    modificaTabella() {
      this.modifica_attivo = true;
    },
    async playQuery(val) {
      let query_str = "";
      if (this.tabella_query_editor_sel.parametri.length != 0) {
        this.tabella_query_editor_sel.parametri.forEach((p) => {
          console.log("parametro", p);
          console.log("match parametro in query", p.cod);
          query_str =
            query_str != ""
              ? query_str.replaceAll(p.cod, p.value)
              : this.tabella_query_editor_sel.query.replaceAll(p.cod, p.value);
          console.log("query con params:", this.tabella_query_editor_sel.query);
        });
      } else {
        query_str = this.tabella_query_editor_sel.query;
      }

      console.log(val);
      this.overlay3 = true;
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "performquery",
          token: localStorage.user_token,
          // id_query: val != null ? val : this.tabella_full.id_query,
          query_string: query_str,
          tabelle: this.tabella_query_editor_sel.tabelle,
        },
      };

      await this.$store
        .dispatch("api", request)
        .then((res) => {
          console.log("res:", res);
          if (res.status === 200) {
            if (res.data.result.length != 0) {
              this.array_tabelle_preview = [];
              for (const [e, value] of Object.entries(res.data.result)) {
                let obj_tmp = {
                  colonne: [],
                  name: e,
                  result: value,
                };

                let headers = [];
                for (let field in value[0]) {
                  headers.push({
                    text: field.includes("#")
                      ? field.split("#")[1].replaceAll("_", " ")
                      : field.replaceAll("_", " "),
                    value: field,
                    sortable: false,
                  });
                }

                obj_tmp.colonne = headers;
                this.array_tabelle_preview.push(obj_tmp);
              }
              // this.result_query = res.data.result;
              // this.result_query.colonne = res.data.colonne;
              // this.result_query_associated = res.data.result;
              // this.overlay3 = false;
            } else {
              this.$refs.SnackbarQV.print(
                "error",
                "Nessun risultato disponibile per questa query."
              );
              this.overlay3 = false;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            this.overlay3 = false;
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          this.overlay3 = false;
        });
    },
    salvaTabella() {
      this.overlay = true;
      if (
        this.tabella_full_sel.titolo == "" ||
        this.tabella_full_sel.modulo == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Titolo tabella o Modulo tabella assente."
        );
        this.overlay = false;
        return;
      }

      // costruisco l oggetto
      // query, params, colonne prese dall oggetto di matteo
      // titolo e modulo dal mio
      let des = this.tabella_full_sel.query[0].descrizione;
      this.tabella_full_sel.query = new Array();
      this.tabella_full_sel.query.push(Object.assign({}, this.query_sel));
      this.tabella_full_sel.query[0].descrizione = des;

      // this.tabella_query_editor_sel.colonne.forEach((colonna) => {
      //   colonna.value.split("#")[1];
      // });

      this.tabella_full_sel.colonne = this.tabella_query_editor_sel.colonne;
      this.tabella_full_sel.params = this.tabella_query_editor_sel.parametri;
      this.tabella_full_sel.query[0].query = this.tabella_query_editor_sel.query;

      // console.log("query oroginale", this.original_query);
      // console.log("query mod", this.tabella_query_editor_sel.query);
      if (
        this.tabella_full_sel.query[0].query === "" ||
        this.tabella_full_sel.query[0].query === null
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Query mancante o non aggiornata, prova ad analizzare una query."
        );
        this.overlay = false;
        return;
      }

      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getqueryassociate",
          token: localStorage.user_token,
          id_query: this.tabella_full.id_query,
        },
      };

      this.$store.dispatch("api", richiesta).then((res) => {
        if (
          res.data.asqueries.associativequeries.length != 0 &&
          this.tabella_full_sel.colonne.length > 1
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            "Stai cercando di modificare una query Launcher. Torna indietro per creare una nuova tabella."
          );
          this.overlay = false;
          return;
        } else {
          console.log("qui ==> ", this.tabella_full_sel);
          if (this.tabella_full_sel.query1 != null) {
            this.tabella_full_sel.query.query = this.tabella_query_editor_sel.query;
          }

          let request = {
            controller: "Magazzino",
            method: "PUT",
            richiesta: {
              action: "setquerydettaglio",
              token: localStorage.user_token,
              tabella: [this.tabella_full_sel],
            },
          };

          this.overlay = true;

          this.$store
            .dispatch("api", request)
            .then((res) => {
              if (res.status === 200) {
                // if (this.from_adapter === true) {
                //   this.$emit("get_tabella", 1);
                // } else {
                //   this.getTabella();
                //   this.$refs.SnackbarQV.print(
                //     "success",
                //     "Tabella salvata correttamente."
                //   );
                // }
                this.$refs.SnackbarQV.print(
                  "success",
                  "Tabella salvata correttamente."
                );
                this.overlay = false;
                if (this.tabella_full_sel.id_query == -1) {
                  this.goBack();
                }

                // let last_mod = this.tabella_full_sel.id_query != -1 ? "old" : "new";

                // this.$emit("save_table", last_mod);
                // this.$emit("save_table");
              } else {
                this.$refs.SnackbarQV.print(
                  "error",
                  "Errore di comunicazione col server, non è stato possibile caricare i dati."
                );
              }
              this.overlay = false;
            })
            .catch(() => {
              this.overlay = false;
              this.$refs.SnackbarQV.print(
                "error",
                "Errore di comunicazione col server, non è stato possibile caricare i dati."
              );
            });
        }
      });
    },
    // salvaQuery() {
    //   this.query_sel.query = this.tabella_query_editor_sel.query;

    //   console.log(this.query_sel);
    //   // this.query_sel.query = this.query_sel.query
    //   //   .replaceAll("\n", " ")
    //   //   .replaceAll("\r", " ")
    //   //   .replaceAll("\t", " ");

    //   let request = {
    //     controller: "Magazzino",
    //     method: "PUT",
    //     richiesta: {
    //       action: "setquerystatistica",
    //       token: localStorage.user_token,
    //       query: [this.query_sel],
    //     },
    //   };

    //   this.$store
    //     .dispatch("api", request)
    //     .then((res) => {
    //       if (this.from_adapter === true) {
    //         console.log(res);
    //         this.$refs.SnackbarQV.print(
    //           "success",
    //           "Query salvata correttamente."
    //         );
    //       } else {
    //         this.$refs.SnackbarQV.print(
    //           "success",
    //           "Query salvata correttamente."
    //         );
    //         this.playQuery();
    //       }
    //     })
    //     .catch(() => {
    //       this.$refs.SnackbarQV.print(
    //         "error",
    //         "Errore di comunicazione col server, non è stato possibile caricare i dati."
    //       );
    //     });
    // },
  },
  created() {},
  mounted() {
    this.getTabelleModuli();
  },
};
</script>
<style scoped>
.record_tabella[data-deleted] {
  background-color: #ffcccc !important;
}
.record_tabella[data-deleted]:hover {
  background-color: #ffb3b3 !important;
}
</style>